'use strict';

import { slideToggle } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const listTableContents = document.querySelector('.ls-contents__list');
  const titlesMain = document.querySelectorAll('main h2');
  let tableContentList = '';

  if(listTableContents && titlesMain) {
    titlesMain.forEach((title) => {
      let anchor = title.innerHTML
        .replace(/\s/g, '-')
        .replace(/\'|\"|\`|\’|\W-/g, '')
        .toLowerCase();
      title.setAttribute('id', anchor);
      tableContentList += `<li class="ls-contents__item"><a href="#${anchor}" class="ls-contents__link">${title.innerHTML}</a></li>`;
    });

    listTableContents.innerHTML = tableContentList;
  }

  const btnTableContents = document.querySelector('.ls-contents__button');

  if(btnTableContents) {
    btnTableContents.addEventListener('click', (e) => {
      if(e.target.closest('.ls-contents__button--aside') && document.body.offsetWidth >= 1024) {
        return false;
      }

      e.target.classList.toggle('ls-contents__button--opened');
      slideToggle(e.target.nextElementSibling);
    })
  }

  // scroll to
  const linksTableContents = document.querySelectorAll('.ls-contents__link');
  const header = document.querySelector('header');

  if(linksTableContents) {
    linksTableContents.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const link = item.getAttribute('href');
        const blockID = link.substring(link.indexOf('#'));
        const elID = document.querySelector(blockID);
        const topOffset = header.offsetHeight + 24;
        const elementPosition = elID.getBoundingClientRect().top;
        const offsetPosition = elementPosition - topOffset;

        window.scrollBy({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }

  // aside
  const listTableContentsAside = document.querySelector('.ls-contents__list--aside');
  if(listTableContentsAside) {
    window.addEventListener('resize', () => {
      if(document.body.offsetWidth >= 1024) {
        listTableContentsAside.previousElementSibling.classList.remove('ls-contents__button--opened');
        listTableContentsAside.removeAttribute('style');
      }
    })
  }
});